import { exchangeTokenOptions, baseAPI, isTestnet, networkCCExchangeOptions } from "utils/configs";

import useRequest from "utils/useRequest";

import { NetworkTypeDTO } from "models/DTO";

export const useTeleSwapApi = () => {
    const request = useRequest();

    const getSupportedPairsExchange = async () => {
        try {
            let runeRes: any = [];
            try {
                runeRes = await request.get(`${baseAPI}/rune/supported-rune-tokens/`);
            } catch (e) {
                console.log(e);
            }
            // let _sourceNetworks: any = [];
            // let _targetNetworks: any = [];
            // let _pairs: any = [];
            // try {
            //     const pairData = await request.get(`${baseAPI}/general/network-and-tokens`);
            //     _sourceNetworks = pairData?.data?.sourceNetworks.filter((i: any) => i.status == "Active");
            //     _targetNetworks = pairData?.data?.targetNetworks.filter((i: any) => i.status == "Active");
            //     _pairs = pairData?.data?.pairs;
            // } catch (e) {
            //     console.log(e);
            // }

            // const sourceNetworks = (_sourceNetworks || []).map((i: any) => {
            //     const _i = { key: capitalize(i.name), value: capitalize(i.name), icon: "BTC" };
            //     return _i;
            // });
            // const targetNetworks = (_targetNetworks || []).map((i: any) => {
            //     const _i = { key: capitalize(i.name), value: capitalize(i.name), icon: i?.name?.toLowerCase() };
            //     return _i;
            // });

            // const networksOptions = [...sourceNetworks, { key: "All", value: "All", icon: null }, ...targetNetworks];

            // const brc20Res: any = await request.get(`${baseAPI}/brc20/supported-brc20-tokens/`);

            const runeTokenOptionsPolygon = (runeRes?.data?.polygon || []).map((i: any) => {
                const _i = {
                    key: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                    value: {
                        address: i.address,
                        symbol: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                        decimal: i.decimal,
                        icon: i.symbol?.toLowerCase(),
                        symbolPrice: i.symbol?.toUpperCase(),
                        name: i.name,
                        type: "rune",
                        canWrap: true,
                        canUnwrap: true,
                        network: "Bitcoin",
                    },
                    icon: i.symbol?.toLowerCase(),
                };
                return _i;
            });
            const runeEVMTokenOptionsPolygon = (runeRes?.data?.polygon || []).map((i: any) => {
                const _i = {
                    key: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                    value: {
                        address: i.address,
                        symbol: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                        decimal: i.decimal,
                        icon: i.symbol?.toLowerCase(),
                        symbolPrice: i.symbol?.toUpperCase(),
                        name: i.name,
                        type: "evm-rune",
                        canWrap: true,
                        canUnwrap: true,
                        network: NetworkTypeDTO.polygon,
                    },
                    icon: i.symbol?.toLowerCase(),
                };
                return _i;
            });

            const brc20TokenOptionsBSC: any[] = [];
            // (brc20Res?.data?.bsc || []).map((i: any) => {
            //     const _i = {
            //         key: i.tick?.toUpperCase(),
            //         value: {
            //             address: i.address?.toLowerCase(),
            //             symbol: i.tick?.toUpperCase(),
            //             decimal: i.decimal,
            //             icon: i.tick?.toLowerCase(),
            //             symbolPrice: i.tick?.toUpperCase(),
            //             type: "brc20",
            //             network: "Bitcoin",
            //         },
            //         icon: i.tick?.toLowerCase(),
            //     };
            //     return _i;
            // });
            const brc20EVMWrapTokenOptionsBSC: any[] = [];
            // (brc20Res?.data?.bsc || []).map((i: any) => {
            //     const _i = {
            //         key: i.tick?.toUpperCase(),
            //         value: {
            //             address: i.address?.toLowerCase(),
            //             symbol: i.tick?.toUpperCase(),
            //             decimal: i.decimal,
            //             icon: i.tick?.toLowerCase(),
            //             symbolPrice: i.tick?.toUpperCase(),
            //             type: "evm-brc20",
            //             network: NetworkTypeDTO.binance,
            //         },
            //         icon: i.tick?.toLowerCase(),
            //     };
            //     return _i;
            // });

            const runeTokenOptionsOther = (runeRes?.data?.polygon || []).map((i: any) => {
                const _i = {
                    key: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                    value: {
                        address: i.address,
                        symbol: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                        decimal: i.decimal,
                        icon: i.symbol?.toLowerCase(),
                        symbolPrice: i.symbol?.toUpperCase(),
                        name: i.name,
                        type: "rune",
                        canWrap: true,
                        canUnwrap: true,
                        network: "Bitcoin",
                        disable: true,
                    },
                    icon: i.symbol?.toLowerCase(),
                };
                return _i;
            });

            const getRuneEVMTokenOptionsOther = (network: string) => {
                return (runeRes?.data?.polygon || []).map((i: any) => {
                    const _i = {
                        key: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                        value: {
                            address: i.address,
                            symbol: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                            decimal: i.decimal,
                            icon: i.symbol?.toLowerCase(),
                            symbolPrice: i.symbol?.toUpperCase(),
                            name: i.name,
                            type: "evm-rune",
                            canWrap: true,
                            canUnwrap: true,
                            network: network,
                            disable: true,
                        },
                        icon: i.symbol?.toLowerCase(),
                    };
                    return _i;
                });
            };

            const getRuneEVMTokenOptionsCrossChain = (network: string) => {
                return (runeRes?.data?.polygon || []).map((i: any) => {
                    const _i = {
                        key: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                        value: {
                            address: i.address,
                            symbol: isTestnet ? "DOG" : i.symbol?.toUpperCase(),
                            decimal: i.decimal,
                            icon: i.symbol?.toLowerCase(),
                            symbolPrice: i.symbol?.toUpperCase(),
                            name: i.name,
                            type: "evm-rune",
                            canWrap: true,
                            canUnwrap: true,
                            network: network,
                            disable: false,
                        },
                        icon: i.symbol?.toLowerCase(),
                    };
                    return _i;
                });
            };

            const brc20TokenOptionsOther: any[] = [];
            // (brc20Res?.data?.bsc || []).map((i: any) => {
            //     const _i = {
            //         key: i.tick?.toUpperCase(),
            //         value: {
            //             address: i.address?.toLowerCase(),
            //             symbol: i.tick?.toUpperCase(),
            //             decimal: i.decimal,
            //             icon: i.tick?.toLowerCase(),
            //             symbolPrice: i.tick?.toUpperCase(),
            //             type: "brc20",
            //             network: "Bitcoin",
            //             disable: true,
            //         },
            //         icon: i.tick?.toLowerCase(),
            //     };
            //     return _i;
            // });

            const getBrc20EVMWrapTokenOptionsOther = (network: string) => {
                return [];
                //  (brc20Res?.data?.bsc || []).map((i: any) => {
                //     const _i = {
                //         key: i.tick?.toUpperCase(),
                //         value: {
                //             address: i.address?.toLowerCase(),
                //             symbol: i.tick?.toUpperCase(),
                //             decimal: i.decimal,
                //             icon: i.tick?.toLowerCase(),
                //             symbolPrice: i.tick?.toUpperCase(),
                //             type: "evm-brc20",
                //             network: network,
                //             disable: true,
                //         },
                //         icon: i.tick?.toLowerCase(),
                //     };
                //     return _i;
                // });
            };

            const getExchangeTokenOptions = (network: string) => {
                // const _ii = {
                //     key: "BTC",
                //     value: {
                //         address: contractAddress?.[network].teleBTCAddress,
                //         symbol: "BTC",
                //         decimal: 8,
                //         icon: "BTC",
                //         symbolPrice: "BTC",
                //         type: "btc",
                //         network: "Bitcoin",
                //     },
                //     icon: "BTC",
                // };

                // const runeTokenOptionsPolygon_ = (_pairs || []).filter(
                //     (i: any) =>
                //         capitalize(i.targetNetwork) === network &&
                //         !(
                //             i.sourceSymbol !== "PUPS" &&
                //             i.sourceSymbol !== "DOG" &&
                //             i.targetSymbol !== "PUPS" &&
                //             i.targetSymbol !== "DOG"
                //         ),
                // );
                // debugger;
                // const runeEvmTokenOptionsPolygon__ = (runeTokenOptionsPolygon_ || []).map((i: any) => {
                //     const _i = {
                //         key: i.symbol?.toUpperCase(),
                //         value: {
                //             address: i.address,
                //             symbol: i.symbol?.toUpperCase(),
                //             decimal: i.decimal,
                //             icon: i.symbol?.toLowerCase(),
                //             symbolPrice: i.symbol?.toUpperCase(),
                //             name: i.name,
                //             type: "evm-rune",
                //             network: NetworkTypeDTO.polygon,
                //         },
                //         icon: i.symbol?.toLowerCase(),
                //     };
                //     return _i;
                // });
                // const runeTokenOptionsPolygon__ = (runeTokenOptionsPolygon_ || []).map((i: any) => {
                //     const _i = {
                //         key: i.symbol?.toUpperCase(),
                //         value: {
                //             address: i.address,
                //             symbol: i.symbol?.toUpperCase(),
                //             decimal: i.decimal,
                //             icon: i.symbol?.toLowerCase(),
                //             symbolPrice: i.symbol?.toUpperCase(),
                //             name: i.name,
                //             type: "rune",
                //             network: "Bitcoin",
                //         },
                //         icon: i.symbol?.toLowerCase(),
                //     };
                //     return _i;
                // });

                // const _iii = (_pairs || []).filter(
                //     (i: any) =>
                //         capitalize(i.targetNetwork) === network &&
                //         i.sourceSymbol !== "PUPS" &&
                //         i.sourceSymbol !== "DOG" &&
                //         i.targetSymbol !== "PUPS" &&
                //         i.targetSymbol !== "DOG",
                // );
                // debugger;
                // const _iiii = (_iii || []).map((i: any) => {
                //     const _i = {
                //         key: i?.targetToken?.symbol?.toUpperCase(),
                //         value: {
                //             address: i?.targetToken?.contractAddress?.toLowerCase(),
                //             symbol: i?.targetToken?.symbol?.toUpperCase(),
                //             decimal: i?.targetToken?.decimal,
                //             icon: i?.targetToken?.symbol?.toLowerCase(),
                //             symbolPrice: i?.targetToken?.symbol?.toUpperCase(),
                //             type: "evm",
                //             canWrap: i.swapFromSource,
                //             canUnwrap: i.swapFromTarget,
                //             network: network,
                //         },
                //         icon: i?.targetToken?.symbol?.toLowerCase(),
                //     };
                //     return _i;
                // });
                // return [_ii, ..._iiii];
                return exchangeTokenOptions?.[network];
            };

            const tokenOptions: any = {
                All: isTestnet
                    ? [
                          ...exchangeTokenOptions?.[NetworkTypeDTO.ton],
                          //   ...runeTokenOptionsOther,
                          //   ...brc20TokenOptionsOther,
                          //   ...getBrc20EVMWrapTokenOptionsOther(NetworkTypeDTO.ton),
                          //   ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.ton),
                      ]
                    : [
                          ...runeEVMTokenOptionsPolygon,
                          ...getExchangeTokenOptions(NetworkTypeDTO.polygon),
                          ...runeTokenOptionsPolygon,

                          ...getExchangeTokenOptions(NetworkTypeDTO.binance),
                          ...runeTokenOptionsOther,
                          ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.binance),

                          //   ...exchangeTokenOptions?.[NetworkTypeDTO.bsquared],
                          //   ...runeTokenOptionsOther,
                          //   ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.bsquared),

                          //   ...exchangeTokenOptions?.[NetworkTypeDTO.bob],
                          //   ...runeTokenOptionsOther,
                          //   ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.bob),

                          ...getExchangeTokenOptions(NetworkTypeDTO.ethereum),
                          ...runeTokenOptionsPolygon,

                          ...getExchangeTokenOptions(NetworkTypeDTO.arbitrum),
                          ...runeTokenOptionsPolygon,

                          ...getExchangeTokenOptions(NetworkTypeDTO.optimism),
                          ...runeTokenOptionsPolygon,

                          ...getExchangeTokenOptions(NetworkTypeDTO.base),
                          ...runeTokenOptionsPolygon,

                          ...getExchangeTokenOptions(NetworkTypeDTO.ton),
                          ...runeTokenOptionsOther,
                          ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.ton),
                      ],
                Polygon: [
                    ...runeEVMTokenOptionsPolygon,
                    ...getExchangeTokenOptions(NetworkTypeDTO.polygon),
                    ...runeTokenOptionsPolygon,
                ],
                Bsc: [
                    ...getExchangeTokenOptions(NetworkTypeDTO.binance),
                    ...runeTokenOptionsOther,
                    ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.binance),
                ],
                BSquared: [
                    // ...getExchangeTokenOptions(NetworkTypeDTO.bsquared),
                    // ...runeTokenOptionsOther,
                    // ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.bsquared),
                ],
                BOB: [
                    // ...getExchangeTokenOptions(NetworkTypeDTO.bob),
                    // ...runeTokenOptionsOther,
                    // ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.bob),
                ],
                Ethereum: [...getExchangeTokenOptions(NetworkTypeDTO.ethereum), ...runeTokenOptionsPolygon],
                Arbitrum: [...getExchangeTokenOptions(NetworkTypeDTO.arbitrum), ...runeTokenOptionsPolygon],
                Optimism: [
                    ...getExchangeTokenOptions(NetworkTypeDTO.optimism),
                    ...runeTokenOptionsPolygon,
                    ...brc20TokenOptionsOther,
                ],
                Base: [...getExchangeTokenOptions(NetworkTypeDTO.base), ...runeTokenOptionsPolygon],
                Ton: [
                    ...getExchangeTokenOptions(NetworkTypeDTO.ton),
                    ...runeTokenOptionsOther,
                    ...getRuneEVMTokenOptionsOther(NetworkTypeDTO.ton),
                ],
            };
            return { tokenOptions, networksOptions: networkCCExchangeOptions };
        } catch (error) {
            return { tokenOptions: exchangeTokenOptions, networksOptions: networkCCExchangeOptions };
        }
    };

    return {
        getSupportedPairsExchange,
    };
};
